import { arbitrum } from "wagmi/chains";
import assert from "assert";

import { is0X } from "util/check";
import { getEnv } from "app/config";
const chains = [arbitrum];

const POOLS: {
  address: `0x${string}`;
  uniswapAddress: `0x${string}`;
  chainId: number;
}[] = [
  {
    // fweth-usdc
    address: "0x7122de2D8146d114300e0442E561D527983b24f9",
    uniswapAddress: "0x035b26AF837e78798AD7c89050939B9AB2E192A0",
    chainId: 421613, // arbitrum-goerli
  },
  // {
  //   // arb-fweth
  //   address: "0xe11d9181DDE67dED8f132aebcdd2421674b8e0C7",
  //   uniswapAddress: "0xf97c7F7ccBB90ba32d3fb01aF18c8FFf5A94Bd65",
  //   chainId: 421613,
  // },
  // {
  //   // gmx-fweth
  //   address: "0x1CBe1BAad5dD650468E760286269F2fb302f3e3a",
  //   uniswapAddress: "0x03fA449776FBE2a38771BD638be94E32592372f6",
  //   chainId: 421613,
  // },
  {
    // arb-usdc
    address: "0x5e9B2299415437c514082286D7FAF99A836e7E86",
    uniswapAddress: "0x9C653a10e4C51e9A784FeE3D5495de91cf3e1c51",
    chainId: 421613,
  },
  {
    // gmx-usdc
    address: "0xaA8333Ef56Eab7376491501A068Ba5b841dc4094",
    uniswapAddress: "0x32859f88bB45fa5e25453Ba044D8fF5Fc243a8D9",
    chainId: 421613,
  },
  {
    // fweth-usdc
    address: "0x1f66032092C5e1Bd89E7346821c9592087394984",
    uniswapAddress: "0x64BF3213666bC357155DDb21aD2404d3Df04e0A1",
    chainId: 80001, // polygon-mumbai
  },
  {
    // fmatic-usdc
    address: "0x115C5E390f142061eD5dFeA0035C5b171069e0eC",
    uniswapAddress: "0xC931D0D6BDCc8b264983533a58ED80F1a3b99ef7",
    chainId: 80001,
  },
  {
    // fweth-usdc
    address: "0xc3300184480512a4e4BA0Ae527e5fD153Bf6E1C2",
    uniswapAddress: "0x9ccf1B78db39e8c7c4B98B1cE06a874a9a93F28d",
    chainId: 280, // zkSync-goerli
  },
];

const walletConnectGetProjectId = () => {
  const projectId = getEnv().NEXT_PUBLIC_WC_PROJECT_ID;
  assert(projectId, "NEXT_PUBLIC_WC_PROJECT_ID env var not defined");
  return projectId;
};

const getPools = (
  env?: string,
  delimeters: { entry: string; value: string } = { entry: ",", value: ":" },
): typeof POOLS => {
  if (env) {
    return env.split(delimeters.entry).map((v) => {
      const [address, uniswapAddress, _chainId] = v.split(delimeters.value);
      const chainId = Number(_chainId);

      if (
        !is0X(address) ||
        !is0X(uniswapAddress) ||
        !Number.isFinite(chainId)
      ) {
        throw new Error("Invalid env var");
      }

      return { address, uniswapAddress, chainId };
    });
  }

  return POOLS;
};

export const getUniswapPool = (marginlyPoolAddress: `0x${string}`) =>
  POOLS.find(({ address }) => address === marginlyPoolAddress)?.uniswapAddress;

/** @deprecated use only inside server-side components */
export const getConfig = (opts?: {
  whitelistId?: string[];
  poolsEnv?: string;
}) => {
  const projectId = walletConnectGetProjectId();

  return {
    projectId,
    pools: getPools(opts?.poolsEnv),
    chains: chains.filter((chain) => {
      // if (HIDDEN_FRONTEND_CHAINS.includes(chain.id)) {
      //   return true;
      // }

      if (!opts?.whitelistId) {
        return true;
      }

      return opts.whitelistId.includes(chain.id.toString());
    }),
  };
};
